import React, { Component, Suspense } from "react";
import "./assets/styles/bootstrap.min.css";
import "./assets/styles/fontawesome.min.css";
import "./assets/styles/animate.min.css";
import "./assets/styles/flaticon.css";
import "./assets/styles/boxicons.min.css";

import "react-toastify/dist/ReactToastify.css";
import "react-accessible-accordion/dist/fancy-example.css";
import "react-tabs/style/react-tabs.css";
import "swiper/css";
import "swiper/css/bundle";

import "./assets/styles/style.css";
import "./assets/styles/responsive.css";

import { refreshToken } from "./redux/actions/refreshingToken";
import { BrowserRouter as Router, Routes } from "react-router-dom";
import routes from "./routes/routes";
import { logout } from "./redux/actions/auth";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
import { withTranslation } from "react-i18next";
import Constants from "./constants/Constants";
import { connect } from "react-redux";
import { default as LoadingOverlay } from "react-loading-overlay-ts";
import { Spinner } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import GoTop from "./components/layout/GoTop";
import Footer from "./components/layout/Footer2";
import Loader from "./components/layout/Loader";
import CookieConsent from "./components/layout/CookieConsent";
import i18n from "../i18n";

class LegacyComponentClass extends Component {
  static propTypes = {
    refreshToken: PropTypes.func,
    logout: PropTypes.func,
    auth: PropTypes.shape({
      isAuthenticated: PropTypes.bool,
      overlayLoading: PropTypes.bool,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
    this.events = ["load", "mousedown", "click", "scroll", "keypress"];

    this.warn = this.warn.bind(this);
    this.logout = this.logout.bind(this);
    this.resetTimeout = this.resetTimeout.bind(this);
    this.handleRefreshToken = this.handleRefreshToken.bind(this);
  }

  componentDidMount() {
    if (!this.props.auth.isAuthenticated) {
      const cookies = new Cookies();
      if (cookies.get("refresh_token")) this.handleRefreshToken();
    }

    this.setState({ isLoading: false });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.auth.isAuthenticated &&
      this.props.auth.isAuthenticated !== prevProps.auth.isAuthenticated
    ) {
      this.setTimeout();
      this.events.forEach((event) =>
        window.addEventListener(event, this.resetTimeout)
      );
    }
    if (
      !this.props.auth.isAuthenticated &&
      this.props.auth.isAuthenticated !== prevProps.auth.isAuthenticated
    ) {
      this.clearTimeout();
      this.events.forEach((event) =>
        window.removeEventListener(event, this.resetTimeout)
      );
    }
  }

  handleRefreshToken = () => {
    this.props.refreshToken();
  };

  clearTimeout() {
    if (this.warnTimeout) clearTimeout(this.warnTimeout);
    if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
  }

  setTimeout() {
    const cookies = new Cookies();
    const rememberMe = cookies.get("rememberMe") || null;
    if (rememberMe !== null && parseInt(rememberMe) === 1) {
      return;
    }

    this.warnTimeout = setTimeout(
      this.warn,
      (Constants.LOGOUT_TIME_OUT - Constants.WARNING_TIME_OUT) * 1000
    );
    this.logoutTimeout = setTimeout(
      this.logout,
      Constants.LOGOUT_TIME_OUT * 1000
    );
  }

  resetTimeout() {
    this.clearTimeout();
    this.setTimeout();
  }

  warn() {
    toast.warn(
      i18n.t("session-timeout-warning", {
        seconds: Constants.WARNING_TIME_OUT,
      }),
      { autoClose: Constants.WARNING_TIME_OUT * 1000 }
    );
  }

  logout() {
    this.props.logout();
    window.location.reload();
  }

  render() {
    return (
      <Router>
        <div className="App">
          <LoadingOverlay
            active={this.props.auth.overlayLoading}
            spinner={<Spinner />}
            spinnerSize="large"
            message="Loading..."
          >
            <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
              <ToastContainer />
              <div>
                <Routes>{routes}</Routes>
              </div>
            </div>

            <Footer />
            <CookieConsent />
          </LoadingOverlay>

          <Loader loading={this.state.isLoading} />

          <GoTop scrollStepInPx="50" delayInMs="16.66" />
        </div>
      </Router>
    );
  }

  componentWillUnmount() {
    this.clearTimeout();
    this.events.forEach((event) =>
      window.removeEventListener(event, this.resetTimeout)
    );
  }
}

const MyComponent = withTranslation()(LegacyComponentClass);

function App(props) {
  return (
    <Suspense
      fallback={<div className={"suspend-loading"}>Loading&#8230;</div>}
    >
      <MyComponent {...props} />
    </Suspense>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  refreshToken: () => dispatch(refreshToken()),
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
